import Axios from 'axios'
const reportPendingSamplesService = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.PENDING_SAMPLES_REPORT
    return AxiosInstance
  },
  getPendingSamplesReport(data) {
    return this.axios().get(
      'report?' + 'startDate=' + data.releaseDateStart + '&endDate=' + data.releaseDateEnd + '&type=' + data.exportWay,
      { responseType: 'arraybuffer' }
    )
  }
}
export default reportPendingSamplesService
